<template>
    <div class="product-image">
        <a role="button" class="product-image-link" v-if="hasImage" @click="openImageInModal">
            <img :src="smallThumb" width="50" :alt="product.name">
        </a>
        <div class="image-icon" v-else>
            <b-icon icon="image" size="is-large"/>
        </div>
    </div>
</template>

<script>
import ProductImageModal from "@/modules/products/components/ProductImageModal";

export default {
    name: "ProductImage",
    props: {
        product: {
            type: Object,
            required: true
        }
    },

    computed: {
        hasImage() {
            return !!this.product.image;
        },
        image() {
            return this.product.image;
        },
        smallThumb() {
            if (this.product.image && this.product.image.thumbs) {
                return this.product.image.thumbs.small;
            }
            return null
        },
        largeThumb() {
            if (this.product.image && this.product.image.thumbs) {
                return this.product.image.thumbs.large;
            }
            return null
        }
    },
    methods: {
        openImageInModal() {
            this.$buefy.modal.open({
                component: ProductImageModal,
                canCancel: [],
                props: {
                    title: this.product.name,
                    imageUrl: this.largeThumb,
                    description: this.product.description
                }
            })
        }
    }
}
</script>

<style lang="scss">
.product-image {
    .image-icon {
        display: flex;
        width: 50px;
        height: 50px;
        background-color: #f2f2f2;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}
</style>

